import {
  EditModule,
  FilterModule,
  FormatModule,
  SortModule,
  Tabulator as TabulatorCore,
} from "tabulator-tables";

TabulatorCore.registerModule([
  EditModule,
  FilterModule,
  FormatModule,
  SortModule,
]);

export default TabulatorCore;
